import type { UserCountry } from 'types/users.types';

export const version = import.meta.env.VITE_APP_VERSION;
export const sentryRelease = import.meta.env.VITE_APP_SENTRY_RELEASE || version;
export const environment = import.meta.env.VITE_APP_ENV || 'development';
export const isProduction = environment === 'production';
export const product = import.meta.env.VITE_APP_PRODUCT || 'web';
export const amplitudeKey = import.meta.env.VITE_APP_AMPLITUDE_KEY;
export const tapFiliateId = import.meta.env.VITE_APP_TAPFILIATEID;
export const pdfWorkerName = import.meta.env.VITE_APP_PDF_WORKER_NAME;

export const slackHooks = {
  translation: import.meta.env.VITE_APP_SLACK_TRANSLATION_HOOK,
  chift: import.meta.env.VITE_APP_SLACK_CHIFT_HOOK,
};

export const recaptcha = {
  key: import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY,
};

export const stripe: { key: Record<UserCountry, string> } = {
  key: {
    de: import.meta.env.VITE_APP_STRIPE_GERMANY_PUBLIC_KEY as string,
    be: import.meta.env.VITE_APP_STRIPE_BELGIUM_PUBLIC_KEY as string,
  },
};

const customENV: { baseUrl: string; filesUrl: string; redirectUrl: string } =
  localStorage.getItem('customENV') &&
  JSON.parse(localStorage.getItem('customENV') || '{}');

export const accountableAPI: typeof customENV =
  customENV && environment !== 'production'
    ? customENV
    : {
        baseUrl: import.meta.env.VITE_APP_ACCOUNTABLE_API_BASE_URL,
        filesUrl: import.meta.env.VITE_APP_ACCOUNTABLE_API_FILES_URL,
        redirectUrl: import.meta.env.VITE_APP_REDIRECT_URL,
      };

export const pusher = {
  key: import.meta.env.VITE_APP_PUSHER_KEY as string,
};
